import React from "react";
import Moment from "react-moment";
import { Link, NavLink } from "react-router-dom";
import { FORMAT_DATE_MOMENT, TYPE_TESTS } from "../../../../api/constant";
import Select from "react-select";

import LineTitle from "../../../app/atoms/LineTitle";
import Toggle from "react-toggle";
import { useAuth } from "../../../../context/security/AuthProvider";
import { customStyles } from "../../../../utilities/select-styles.utilities";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBox, faCaretDown } from "@fortawesome/free-solid-svg-icons";
import {
  useActionsTests,
  useTests,
  useDispatchTestIndex,
} from "../../../../context/inventory/TestIndexActiveProvider";
import { types } from "../../../../reducers/inventory/testsActiveReducer";
const TestIndexActive = () => {
  const state = useAuth();
  const dispatch = useDispatchTestIndex();
  const {
    tests: { filter, elements: listTests },
    tests_id_deploy,
  } = useTests();
  const actions = useActionsTests();
  const getTypeName = (type) => {
    const filter = TYPE_TESTS.filter((t) => t.code === type);
    return filter.length > 0 ? filter[0].name : null;
  };
  return (
    <div className="container">
      <LineTitle title={"Lista de pruebas"} />
      <div style={{ marginTop: "9px" }} className="flex justify-betwen">
        <div>
          <label htmlFor="">Seleccione tipo de prueba</label>
          <Select
            placeholder="Tipo prueba"
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.code}
            options={TYPE_TESTS}
            styles={customStyles}
            isClearable
            isMulti={false}
            onChange={(e) =>
              dispatch({
                type: types.CHANGE_FILTER_TESTS,
                payload: { field: "type", value: e ? e.code : null },
              })
            }
          />
        </div>
      </div>
      <br />
      <table className="table table-default-app">
        <thead className="thead-dark">
          <tr>
            <th scope="col">ID</th>
            <th scope="col">Ref</th>
            <th scope="col">Fecha creación</th>
            <th scope="col">Nombre de prueba</th>
            <th scope="col">Versiónes</th>
            <th scope="col">Tipo</th>
            <th scope="col">Descripción</th>
            <th scope="col">Observ.</th>
            <th scope="col">Archivos</th>

            <th scope="col">Ultima modificación </th>
          </tr>
        </thead>
        <tbody>
          {listTests.map((test,i) => {
            return (
              <>
                <tr key={i}>
                  <td>
                    {test.versions.length > 0 && (
                      <FontAwesomeIcon
                        onClick={() =>
                          dispatch({
                            type: types.TOGGLE_TEST_LIST,
                            payload: test.id,
                          })
                        }
                        className="blue cursor-pointer"
                        icon={faCaretDown}
                      />
                    )}
                  </td>
                  <td>
                    {" "}
                  
                      {test.reference}
                 
                  </td>
                  <td>
                    {" "}
                    <Moment format={FORMAT_DATE_MOMENT}>
                      {test.created_at}
                    </Moment>
                  </td>
                  <td>{test.name}</td>
                  <td>{test.versions_count}</td>
                  <td> {getTypeName(test.type)}</td>
                  <td>{test.description}</td>
                  <td></td>
                  <td></td>

                  <td>
                    <Moment
                      date={test.updated_at}
                      format={FORMAT_DATE_MOMENT}
                    />{" "}
                  </td>
                </tr>
                {tests_id_deploy.includes(test.id) &&
                  test.versions.map((v, index) => {
                    return (
                      <tr key={v.id}>
                        <td>
                          {" "}
                          <Link to={`/inventory/test/${v.id}/exit/`}>{v.id}</Link>{" "}
                        </td>
                        <td>
                          {test.reference} - {v.version}{" "}
                        </td>

                        <td>
                          <Moment
                            date={v.created_at}
                            format={FORMAT_DATE_MOMENT}
                          />
                        </td>
                        <td> {v.name} </td>
                        <td></td>
                        <td> {getTypeName(v.type)}</td>
                        <td>{v.description}</td>
                        <td>{v.notes_count}</td>
                        <td>{v.documents_count}</td>

                        <td>
                          {" "}
                          <Moment
                            date={v.updated_at}
                            format={FORMAT_DATE_MOMENT}
                          />{" "}
                        </td>
                      </tr>
                    );
                  })}
              </>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
export default TestIndexActive;
